'use client';

import useSWR from 'swr';
import { transactionsApi } from '@/lib/api';
import type { TransactionDetails } from '@/types';
import { TRANSACTION_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useTransactionDetails(id: string | null | undefined) {
  const authedFetch = useAuthedFetcher();

  return useSWR<TransactionDetails>(
    id ? ['transaction-details', id] : null,
    () => authedFetch((token) => transactionsApi.getOne(token, id!)),
    TRANSACTION_SWR_OPTIONS,
  );
}
